import React, { useState } from 'react';
import { cn } from 'lib/utils';
import Spinner from '../../components/spinners/global';
import { marketplaceEmbedUrl } from 'utils/urlGenerator';
import { ENV } from 'utils/config';

const Marketplace = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const embedPageUrl = marketplaceEmbedUrl(ENV || 'production');

  return (
    <>
      <Spinner isLoading={iframeLoaded ? 0 : 1} />
      <iframe
        src={embedPageUrl}
        onLoad={() => setIframeLoaded(true)}
        className={cn(
          'absolute w-full h-screen top-10 -left-5 overflow-hidden pb-8',
          'max-xl:top-25 max-xl:left-4',
          iframeLoaded ? 'block' : 'hidden'
        )}
      />
    </>
  );
};

export default Marketplace;
